import * as React from "react";

const ArrowTwoIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="70" height="63">
    <path
      fill="none"
      stroke="#D3E205"
      strokeMiterlimit="5"
      strokeWidth="4"
      d="M32.305 3.155a2 2 0 0 1 2.822-.196l30.8 26.795a2 2 0 0 1 0 3.018l-30.8 26.795a2 2 0 0 1-3.313-1.51v-9.794H4a2 2 0 0 1-2-2v-30a2 2 0 0 1 2-2h27.814V4.468a2 2 0 0 1 .38-1.172z"
    ></path>
  </svg>
);

export default ArrowTwoIconSVG;


